import { toast } from "sonner";

export function toastUtil(message: string, type: "success" | "error") {
  toast.success(message, {
    style:
      type === "success"
        ? {
            background: "green",
            color: "white",
          }
        : {
            background: "red",
            color: "white",
          },
  });
}
